import { Injectable } from '@angular/core';
import { Buffer, Workbook } from 'exceljs';
import * as fs from 'file-saver';

import { Extension } from '../enums/extensions.enum';
import { FileType } from '../enums/file-type.enum';
import { EXPORT_META_NAME_FILE } from '../constants/export-meta-name-file.const';

@Injectable({
  providedIn: 'root',
})
export class BydExportService {
  /**
   * Creates excel from data array.
   *
   * @param data array of data to be converted to excel.
   * @param fileName File name.
   */
  public exportToExcel(data: string[][], fileName: string): void {
    if (!data) return;
    const workbook = new Workbook();
    const workSheet = workbook.addWorksheet();
    data.forEach((row: string[]) => {
      if (row) {
        workSheet.addRow(row);
      }
    });

    workbook.xlsx.writeBuffer().then((fileData: Buffer) => {
      const blob = this.createBlob(fileData, FileType.ExcelFileType);
      this.downloadFile(blob, fileName, Extension.Excel);
    });
  }

  /**
   * Create csv from data array.
   *
   * @param data - rows
   */
  public exportToCsv(data: string[]): void {
    const fileData = this.fileData(data);
    const blob = this.createBlob(fileData, FileType.CsvFileType);
    this.downloadFile(blob, EXPORT_META_NAME_FILE, Extension.CSV);
  }

  /**
   * Prepare rows.
   *
   * @param data - rows
   * @returns - a string witch use to create blob
   */
  private fileData(data: string[]): string {
    const csvContent: string = data
      .map((rowData: string) => {
        if (rowData) return rowData;
      })
      .join('\n');
    return csvContent;
  }

  /**
   * @param data - data to put into the blob.
   * @param fileType - the type of the file.
   * @returns - a blob that contains data.
   */
  private createBlob(data: string | Buffer, fileType: string): Blob {
    return new Blob([data], { type: fileType });
  }

  /**
   * Create Blob object.
   *
   * @param buffer The data that need to be saved.
   * @param fileName File name.
   * @param extension Extension of file
   */
  private downloadFile(buffer: Blob, fileName: string, extension: string): void {
    fs.saveAs(buffer, `${fileName}${extension}`);
  }
}
